export default {
    account: "账户名",
    password:"账户密码",
    verifCode:"验证码",
    changeVerifCode:"点击切换验证码",
    login:"登录",
    accountRequired:"请输入账号名",
    passwordRequired:"请输入账户密码",
    verifCodeRequired:"请输入验证码",
    verifCodeError:"验证码错误"
}


// WEBPACK FOOTER //
// ./src/views/login/login.zh-CN.js